import React, { useMemo } from 'react';
import './SHEventReceipt.css';
import { useLanguage } from '../../../../../LanguageProvider';
import { TbCalendarTime, TbCreditCard, TbMapPin, TbMapSearch, TbWorld } from 'react-icons/tb';

export default function SHEventReceipt({ event, handleCheckoutClicked, activeTab, ticketInfosMap }) {
  const { getTranslation } = useLanguage();

  // 1. Her ticket tipi için tam dolu kayıtları filtrele, başlık, adet ve toplam tutarı çıkart
  const ticketGroups = useMemo(() => {
    return Object.values(ticketInfosMap)
      .map(group => {
        const complete = group.filter(info =>
          info.name?.trim() &&
          info.lastname?.trim() &&
          info.email?.trim() &&
          info.phone?.trim()
        );
        const price = group[0]?.ticketPrice || 0;
        return {
          ticketTitle: group[0]?.ticketTitle || '',
          count: complete.length,
          groupTotal: complete.length * price,    // bu grubun toplamı
        };
      })
      .filter(g => g.count > 0);
  }, [ticketInfosMap]);

  // 2. Toplam kişi sayısını hesapla
  const totalPersons = ticketGroups.reduce((sum, g) => sum + g.count, 0);

  // 3. Alt toplamı (sub total) hesapla
  const subTotal = ticketGroups.reduce((sum, g) => sum + g.groupTotal, 0);

  function formatWithTimezone(timestampSaniye) {
    const date = new Date(Number(timestampSaniye) * 1000);
    const dtf = new Intl.DateTimeFormat('en-GB', {
      timeZone: 'Europe/Istanbul',
      year: 'numeric',
      month: '2-digit',
      day: '2-digit',
      hour: '2-digit',
      minute: '2-digit',
      second: '2-digit',
      hour12: false
    });

    // formatToParts ile gün, ay, yıl, saat, dakika, saniye parçalarını alıyoruz
    const parts = dtf.formatToParts(date).reduce((acc, part) => {
      if (part.type !== 'literal') acc[part.type] = part.value;
      return acc;
    }, {});

    const { day, month, year, hour, minute, second } = parts;
    return `${day}.${month}.${year} ${hour}:${minute}:${second} (UTC+3)`;
  }

  const all = Object.values(ticketInfosMap).flat();
  const hasEmptyInfo = all?.some(ticket =>
            !ticket.name || !ticket.lastname || !ticket.email || !ticket.phone
        );
  return (
    <div className="sh-receipt-container">
      <div className='sh-receipt-card'>
        {/* Dinamik ticket başlıkları ve adetleri */}
        <span className='sh-receipt-row-header'>
          {getTranslation('ticket')}
        </span>
        <span
          className='sh-receipt-row-text'
          style={{ display: 'flex', flexDirection: 'column', gap: '4px' }}
        >
          {ticketGroups.map((g, idx) => (
            <span key={idx}>{`x${g.count} ${g.ticketTitle}`}</span>
          ))}
        </span>

        {/* Toplam kişi sayısı */}
        <span className='sh-receipt-row-header'>
          {getTranslation('person')}
        </span>
        <span className='sh-receipt-row-text'>
          {`${totalPersons} Person`}
        </span>

        {/* Alt toplam */}
        <div style={{ flexDirection: 'column', display: 'flex', width: '100%', alignItems: 'flex-end' }}>
          <span className='sh-receipt-row-header'>
            {getTranslation('subTotal')}
          </span>
          <span className='sh-receipt-row-text' style={{ fontSize: '14px', fontWeight: '600' }}>
            {`${subTotal} TRY`}
          </span>
        </div>

        {activeTab !== "payment" &&
          <button
            disabled={Object.values(ticketInfosMap).every(v => Array.isArray(v) && v.length === 0) || (activeTab===getTranslation("tickets") && hasEmptyInfo)}
            onClick={() => handleCheckoutClicked(subTotal)}
            className="sh-settings-action-button"
            style={{
              marginTop: 0,
              alignSelf: 'auto',
              height: '38px',
              maxHeight: '38px',
              alignItems: 'center',
              justifyContent: 'center',
              paddingInline: '5px',
              fontSize: '15px',
              fontWeight: '600',
              marginBottom: '15px',
              width: '100%',
              display: 'flex',
              gap: '10px'
            }}
          >
            <TbCreditCard size={15} />
            {getTranslation("checkout")}
          </button>
        }
      </div>

      <div className='sh-receipt-card'>
        <span className="sh-location" style={{ alignItems: 'flex-start' }}>
          <TbCalendarTime className="sh-icon" size={18} />
          {formatWithTimezone(event.eventStartDateTime)}
        </span>
        {event?.isOnline === "1" ?
          <div className="sh-location">
            <TbWorld className="sh-icon" />
            <span>{event?.website}</span>
          </div>
          :
          <a
            className='sh-location'
            href={`https://www.google.com/maps?q=${event.locationLatitude},${event.locationLongitude}`}
            target="_blank"
            rel="noopener noreferrer"
            style={{ cursor: 'var(--pointer)', textDecoration: 'none' }} >
            <TbMapPin className="sh-icon" size={18}/>

            {event?.locationAddress}
          </a>
        }

        {event?.isOnline === "0" &&
          <span className="sh-location" style={{ alignItems: 'center' }}>
            <TbMapSearch className="sh-icon" size={18} />
            <button
              className="sh-receipt-map-button"
              onClick={() => {
                const url = `https://www.google.com/maps?q=${event.locationLatitude},${event.locationLongitude}`;
                window.open(url, '_blank', 'noopener,noreferrer');
              }}
            >
              {getTranslation('viewOnMap')}
            </button>
          </span>
        }

      </div>
    </div>
  );
}
